module.exports = __webpack_public_path__ + "static/media/CenterContentBlock.8ea08200.png";